.ADDWrapper
    position: relative
    width: 100%
    min-height: 0
    display: flex
    flex-direction: column
    .ADDOptionsContainer
        padding: 0 20px
        .ADDOptionsTitle
            font-size: 18px
            font-weight: 700
        .ADDOptionsSelectsContainer
            position: relative
            display: flex
            flex-direction: row
            align-items: center
            gap: 20px
            .ADDOptionContainer
                min-width: 0
                flex-grow: 1
                flex-basis: 0
                padding-top: 20px
.ADDWaiting
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: rgb($globalSettingsBackgroundPrimary)
    opacity: 0.3
    cursor: wait
